import { Content } from '../../types';

export const phongNhaContent: Content = {
  title: 'פונג נה – ארץ המערות של וייטנאם',
  imageUrl: '/images/vietnam/phong-nha/phong-nha-bg.jpeg',
  introduction: `פונג נה (Phong Nha) הינה אחת מהפנינים הנסתרות של וייטנאם, הממוקמת במחוז קואנג בין (Quang Binh) שבמרכז המדינה. המקום מפורסם בזכות הפארק הלאומי פונג נה - קה באנג (Phong Nha-Ke Bang), אתר מורשת עולמית של אונסק"ו, המכיל נופים עוצרי נשימה, מערות מרהיבות, נהרות צלולים והזדמנויות לחקר הטבע במיטבו. יעד זה מתאים להרפתקנים, חובבי טבע, צלמים ולמטיילים המחפשים חוויות ייחודיות מחוץ למסלול התיירותי השגרתי.`,
  sections: [
    {
      title: 'אטרקציות מרכזיות בפונג נה',
      content: [
        'מערת פונג נה - אחת המערות המפורסמות ביותר באזור, אשר ניתן להגיע אליה בשייט על הנהר סון (Son). המערה מלאה בתצורות אבן מרשימות ונחשבת לאחת היפות בוייטנאם.',
        'מערת גן עדן (Paradise Cave) - מערה מרהיבה באורך של כ-31 ק"מ, המציגה נטיפים וזקיפים מהמרשימים בעולם. הכניסה למערה כוללת מסלול הליכה עילי המשקיף על נופים ירוקים.',
        'מערת האן סון דונג (Hang Son Doong) - נחשבת למערה הגדולה בעולם וכוללת נהרות תת-קרקעיים, צמחייה ייחודית ואקלים פנימי משלו. בשל מגבלות סביבתיות, הביקור בה מצריך תיאום מראש והרשמה מוקדמת.',
        "המערה הכחולה ונהר צ'אי (Chay River & Dark Cave) - חוויית הרפתקה הכוללת אומגה, שחייה במים צלולים וביקור במערה חשוכה בה ניתן להתרחץ בבוץ טבעי.",
        'טיולי אופניים וכפרי הסביבה - ניתן לצאת לרכיבה על אופניים דרך הכפרים המקומיים ולגלות את אורח החיים הפשוט והמסורתי של התושבים.',
        "תצפיות ונקודות נוף - הפארק הלאומי פונג נה - קה באנג מציע מספר תצפיות מדהימות על הנוף ההררי, הנהרות והג'ונגל העבות.",
      ],
      type: 'list',
    },
    {
      title: 'מערה בפונג נה',
      content: '',
      type: 'image',
      imageUrl: '/images/vietnam/phong-nha/cave.jpeg',
    },
    {
      title: 'שווקים וקניות',
      content: `בעיירה פונג נה אין שווקים גדולים כמו בהאנוי או הו צ'י מין סיטי, אך ניתן למצוא שווקים מקומיים קטנים בהם מוכרים פירות טריים, ירקות, בגדים ומזכרות בעבודת יד. מומלץ לבקר בשוק דונג הוי (Dong Hoi Market) אשר נמצא בעיר הקרובה, כדי לחוות שוק וייטנאמי מסורתי.`,
      type: 'text',
    },
    {
      title: 'לינה בפונג נה',
      content: [
        'Phong Nha Farmstay - מלון כפרי המציע אווירה שלווה, בריכה ונוף מדהים לשדות האורז.',
        'Victory Road Villas - מלון יוקרתי עם חדרים מודרניים ובריכת שחייה.',
        'Easy Tiger Hostel - הוסטל פופולרי בקרב תרמילאים עם אווירה חיה, מוזיקה חיה ופעילויות חברתיות.',
        'Chay Lap Farmstay - מקום אירוח פסטורלי עם פעילויות טבע, כגון קיאקים ושייט על הנהר.',
      ],
      type: 'list',
    },
    {
      title: 'חיי לילה ובילויים',
      content: [
        'Easy Tiger Hostel - בר עם מוזיקה חיה ואווירה תרמילאית מהנה.',
        "Omar's Namaste Indian Restaurant - מסעדה הודית עם אווירה טובה.",
        'Bomb Crater Bar - בר פופולרי השוכן ליד הנהר ומציע קוקטיילים ונוף מרהיב.',
      ],
      type: 'list',
    },
    {
      title: 'שקיעות ותצפיות מומלצות',
      content: [
        'Phong Nha Lake House - מקום מושלם לשבת עם משקה ולצפות בשמש שוקעת מעל האגם.',
        'השדות ליד Phong Nha Farmstay - מומלץ לטיול רגלי בזמן השקיעה ולתצפית על ההרים הירוקים.',
        'הנהר סון - ניתן לצאת לשייט רגוע וליהנות מהשתקפות השמש במים.',
      ],
      type: 'list',
    },
    {
      title: 'דרכי הגעה לפונג נה',
      content: [
        'פונג נה ממוקמת כ -50  ק"מ מעיר החוף דונג הוי (Dong Hoi), המשמשת כשער הכניסה לאזור.',
        "בטיסה - שדה התעופה הקרוב ביותר נמצא בדונג הוי (VDH), עם טיסות פנימיות מהאנוי (Hanoi), הו צ'י מין סיטי (Ho Chi Minh City) ודה נאנג (Da Nang). משדה התעופה ניתן לקחת מונית או הסעה לפונג נה (כשעה נסיעה).",
        "ברכבת - תחנת הרכבת דונג הוי מחוברת לקו הרכבות הראשי של וייטנאם, עם רכבות מהאנוי, הו צ'י מין סיטי, דה נאנג והואה (Hue). מהתחנה ניתן לקחת מונית או אוטובוס לפונג נה.",
        'באוטובוס - אוטובוסים ישירים יוצאים מהאנוי, הואה ונין בין (Ninh Binh) ומגיעים ישירות לפונג נה.',
        'ברכב פרטי או אופנוע - ניתן לשכור רכב או אופנוע ולנסוע בכבישים המובילים לפונג נה, כאשר המסלול מכיוון הואה עובר דרך נופים מרהיבים של כפרים ושדות ירוקים.',
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, פונג נה הינה יעד חובה לכל חובבי הטבע וההרפתקאות, עם מגוון רחב של אטרקציות, חוויות ייחודיות ונופים עוצרי נשימה. בין אם הינכם מתעניינים בחקר מערות, שייט על נהרות, רכיבה על אופניים או פשוט מחפשים שקט ושלווה – פונג נה מציעה חוויה בלתי נשכחת בלב וייטנאם.`,
      type: 'text',
    },
  ],
};
